"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require("../..");
var _SceneLayouts = require("../../constants/SceneLayouts");
var _SourceItemBodyMidSection = require("./SourceItemBodyMidSection.styled");
var _PermissionText = require("../Permissions/PermissionText");
var _constants = require("../../constants");
var SourceItemBodyMedSection = function SourceItemBodyMedSection(_ref) {
  var live = _ref.live,
    isStaged = _ref.isStaged,
    onLiveToggleClicked = _ref.onLiveToggleClicked,
    enableFeature = _ref.enableFeature,
    hovered = _ref.hovered,
    isStagedSourcesActive = _ref.isStagedSourcesActive,
    isMaximumCameraSourcesOn = _ref.isMaximumCameraSourcesOn,
    sourceId = _ref.sourceId,
    isCameraOn = _ref.isCameraOn,
    type = _ref.type;
  var showTitle = 'Show';
  var hideTitle = 'Hide';
  var showLiveButton = !isStaged && hovered && !isStagedSourcesActive;
  var isCameraSource = type === _constants.CAMERA_PRESENTER;
  var isDisabled = isMaximumCameraSourcesOn && !live && !isCameraOn && isCameraSource;
  var handleClick = isDisabled ? function () {} : onLiveToggleClicked;
  var targetElementId = "source-".concat(sourceId, "-cta-button");
  var tooltipText = "".concat(_SceneLayouts.CAMERA_PRESENTER_LIMIT, "/").concat(_SceneLayouts.CAMERA_PRESENTER_LIMIT, " cameras are already active.");
  return /*#__PURE__*/_react["default"].createElement(_SourceItemBodyMidSection.StyledWrapper, {
    enableFeature: enableFeature,
    id: "source-list-item-body-med",
    "data-testid": "source-list-item-body-med"
  }, hovered && !enableFeature && /*#__PURE__*/_react["default"].createElement(_SourceItemBodyMidSection.StyledTextContainer, null, _PermissionText.PERMISSION_TEXT.SHOW_CALLER), showLiveButton && enableFeature && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SourceItemBodyMidSection.StyledButton, {
    "data-testid": "source-cta-button",
    $enableFeature: enableFeature,
    $isLive: live,
    onClick: handleClick,
    isDisabled: isDisabled,
    id: targetElementId,
    "data-dd-action-name": "".concat(live ? hideTitle : showTitle, " - ").concat(sourceId),
    color: "secondary",
    variant: "ghost",
    size: "small"
  }, live ? hideTitle : showTitle), isDisabled && /*#__PURE__*/_react["default"].createElement(_.StyledUncontrolledTooltip, {
    placement: "bottom",
    target: targetElementId
  }, tooltipText)));
};
SourceItemBodyMedSection.propTypes = {
  live: _propTypes["default"].bool,
  enableFeature: _propTypes["default"].bool,
  isStaged: _propTypes["default"].bool,
  onLiveToggleClicked: _propTypes["default"].func,
  hovered: _propTypes["default"].bool,
  isStagedSourcesActive: _propTypes["default"].bool,
  isMaximumCameraSourcesOn: _propTypes["default"].bool,
  sourceId: _propTypes["default"].string,
  isCameraOn: _propTypes["default"].bool,
  type: _propTypes["default"].string
};
var _default = exports["default"] = SourceItemBodyMedSection;